// extracted by mini-css-extract-plugin
module.exports = {"root":"RecentPostsSection-module--root--3g0go","posts":"RecentPostsSection-module--posts--1OPAw","featured":"RecentPostsSection-module--featured--moPmQ"};